import * as yup from "yup";

type Device = {
  id: number;
  name: string;
  description: string;
  warranty_period: number;
  system: string | "open" | "close";
  device_parts: [
    {
      id: number;
      name: string;
      description: string;
      total_bought: number;
      total_sold: number;
      total_maintenance: number;
      remaining_stock: number;
    },
  ];
  total_bought: number;
  total_sold: number;
  total_use_in_setup: number;
  remaining_stock: number;
};

export interface CustomerAddRequest {
  customer_device: {
    device: number;
    date_of_setup: Date;
    date_of_maintenance: Date;
    warranty_start: Date;
    first_setup?: boolean;
  };
  payment?: {
    device: number;
    name_of_payment: string;
    note: string;
    amount: number;
    payment_type: string;
    number_of_installment: number;
    date_of_installment: Date;
    got_amount: number;
  };
  device_part_ids?: string;
  fullname: string;
  description: string;
  phone_number: string;
  phone_number2?: string;
  phone_number3?: string;
  email: string;
  country: string;
  district: string;
  neighbourhood: string;
  street: string;
  flat_number: string;
  lang?: string;
  long?: string;
  address_description: string;
}

export interface CustomerAddResponse {
  id: number;
  fullname: string;
  description: string;
  phone_number: string;
  country: string;
  district: string;
  neighbourhood: string;
  street: string;
  flat_number: string;
  lang: string;
  long: string;
  address_description: string;
  status: number;
}

export interface DeviceListResponse extends Array<Device> {}

export interface DevicePartListResponse
  extends Array<{ id: string; description: string; name: string }> {}

export const stepTwoSchema = yup.object({
  deviceId: yup
    .number()
    .min(0, "Cihaz ID'si en az 0 olmalıdır")
    .required("Cihaz boş bırakılamaz"),
});

export const stepThreeSchema = yup.object({
  name_of_payment: yup.string().required("Ödeme adı boş bırakılamaz"),
  amount: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required("Yapılan iş ücreti boş bırakılamaz"),
  got_amount: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .max(yup.ref("amount"), "Alınan ücret yapılan iş ücretinden fazla olamaz"),
  payment_type: yup.string().notRequired(),
  number_of_installment: yup
    .number()
    .when("payment_type", (payment_type: any, schema) => {
      return payment_type[0] === "ip"
        ? schema
            .required("Taksit sayısı boş bırakılamaz")
            .min(2, "Taksit sayısı 1'dan büyük olmalıdır")
        : schema.notRequired();
    }),
});

export const blankSchema = yup.object({
  name_of_payment: yup.string().notRequired(),
  note: yup.string().notRequired(),
  amount: yup.number().notRequired(),
});

export const stepOneSchema = yup.object({
  fullname: yup.string().required("Müşteri adı soyadı boş bırakılamaz"),
  phone_number: yup
    .string()
    .required("Telefon numarası boş bırakılamaz")
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
  phone_number2: yup
    .string()
    .transform((value) => (value === "" ? undefined : value))
    .nullable()
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
  phone_number3: yup
    .string()
    .transform((value) => (value === "" ? undefined : value))
    .nullable()
    .matches(/^0[0-9]{10}$/, "Geçerli bir telefon numarası girin"),
});

export const getActiveSchema = (tab: number) => {
  switch (tab) {
    case 1:
      return stepOneSchema;
    case 2:
      return stepTwoSchema;
    case 3:
      return stepThreeSchema;
    default:
      return stepOneSchema;
  }
};
